import { Typography, useTheme } from '@mui/material';

import { ATSConnectHiringRequestTestIds } from 'data-testids/ATS';
import { AccordionCTAExpandedProps, IndividualHiringRequestAction } from '../../../types';
import { getConnectCandidateRowActionText, getIsActionRequired } from '../../../utils';
import { actionInfo } from '../../../data';
import { ExpandedActionRow, ExpandedCTAContainer } from '../../../styles/actionsStyles';
import { ActionIcon } from './Icons';
import { useHistory } from 'react-router';
import auth from 'utils/auth';
import { CandidateFeedbackModalTypes, ConnectHiringRequestAction } from '../../../enums';

export const AccordionCTAExpanded: React.FC<AccordionCTAExpandedProps> = ({
  actions,
  applicationLink,
  isExpanded,
  candidateId,
  requirements,
  roleId,
  onOpenModal,
}) => {
  const theme = useTheme();
  const history = useHistory();
  const isSuperAdmin = auth.isSuperAdminUser();

  return (
    <ExpandedCTAContainer
      sx={{ pt: 0.5 }}
      isexpanded={isExpanded}
      data-testid={ATSConnectHiringRequestTestIds.EXPANDED_CTA_CONTAINER}
    >
      {actionInfo
        .slice(0, isSuperAdmin ? actionInfo.length : actionInfo.length - 1)
        .map((data, index) => {
          const actionKey: IndividualHiringRequestAction = data.tooltipText;
          const actionIsMissing = !actions[actionKey];
          const isRequired = getIsActionRequired(actionKey, requirements);

          const handleClick = (event: React.MouseEvent<HTMLInputElement>) => {
            event.stopPropagation();
            if (data.tooltipText === ConnectHiringRequestAction.application) {
              if (!actionIsMissing && applicationLink) {
                history.push(applicationLink);
              }

              return;
            }
            onOpenModal({ candidateId, modalType: data.tooltipText, roleId });
          };

          return (
            <ExpandedActionRow
              data-testid={ATSConnectHiringRequestTestIds.EXPANDED_CTA_ACTION_ROW}
              key={index}
              onClick={
                data.tooltipText === CandidateFeedbackModalTypes.APPLICATION
                  ? undefined
                  : handleClick
              }
              sx={{
                cursor:
                  data.tooltipText === CandidateFeedbackModalTypes.APPLICATION ? null : 'pointer',
              }}
            >
              <ActionIcon
                icon={data.icon}
                isExpanded={isExpanded}
                isMissing={actionIsMissing}
                isRequired={isRequired}
                tooltipText={data.tooltipText}
              />
              <Typography sx={{ paddingLeft: theme.spacing(0.25) }}>
                {getConnectCandidateRowActionText(actionKey, actionIsMissing, isRequired)}
              </Typography>
            </ExpandedActionRow>
          );
        })}
    </ExpandedCTAContainer>
  );
};
